import axios from '../index'

export default {
    getDatosFiscales (idPersona) {
        return axios.get('/panel/alumno/get/' + idPersona)
    },
    getRegimen(){
        return axios.get('/api/v1/sat/regimenes')
    },
    postGuardarDatosFiscales(formData, idPersona){
        return axios.post('/panel/actualizarDatosFiscales/' + idPersona, formData)
    },
    postEliminarDatosFiscales(id){
        return axios.post('/panel/eliminar-datos-fiscales/' + id)
    },

    // LANDING PROCESO DE ADMISION 
    getInformacionProcesoAdmision(idPersona, lastUrl){
        return axios.get('/panel/seguimiento/get/' + idPersona + '/' + lastUrl)
    },
    publicarComentario(payload, id){
        return axios.post('/panel/comentar/' + id, payload)
    },
    postEnviarCorreoProceso(payload){
        return axios.post('/panel/enviarCorreo', payload)
    },
    postCongelar(id){
        return axios.post('/panel/congelar/' + id)
    },
    postReactivar(status, id){
        return axios.post('/panel/reactivar/' + status + '/' + id)
    },
    postDescartar(id){
        return axios.post('/panel/descartar/' + id)
    },
    postAvanzar(id, formData){
        return axios.post('/panel/avanzar/' + id, formData)
    },
    postAvanzarCurp(id, formData){
        return axios.post('/panel/avanzar/' + id, formData)
    },
    postRetroceder(id){
        return axios.post('/panel/retroceder/' + id)
    },

    // INSCRIPCIÓN ACADÉMICA 
    
    getInscripcionAcademica(params){
        return axios.get('/proceso-inscripcion/getRegistrosAcademicos', {params})
    },
    postReinscripcion(formData){
        return axios.post('/proceso-inscripcion/store', formData)
    },
    getAtributo(programa){
        return axios.get('/atributos/porPrograma/' + programa)
    },
    getCiclosEscolares (institucionId) {
        return axios.get('/ciclos-escolares/ciclosPorInstitucion/'+ institucionId)
    },
    postConfirmarInscripcion(formData){
        return axios.post('/proceso-inscripcion/confirmarInscripcion', formData)
    },

    // MAPA DE INSCRIPCIÓN 
    getMapaInscripcion(params){
        return axios.get('/proceso-inscripcion/getMapaInscripcionPorAlumno', {params})
    },
    getLogCalificaciones(params){
        return axios.get('/logs/getLogCorrecionCalificacionesPorPersona', {params})
    },
}